
import { IReferenceDTO, ISummaryDTO } from "../../services/alarm-scheme-data-service/Models";
import AlarmSchemeListUtils, { AlarmSchemeItem, AlarmSchemesFormType } from "../../components/alarm-scheme-list/AlarmSchemeListUtils";
import { IReferenceDTO as ISetpointReferenceDTO, IReferenceAlarmScheduleDTO, IReferenceAlarmSchemeTierDTO, IReferenceAlarmSchemeTierNotificationDTO, IReferenceNotificationListDTO } from "../../services/setpoint-administration-service/Models";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";

const AlarmSchemeAdministrationUtils = {
    mapToFormValues: (model: ISummaryDTO[], 
        referenceData: IReferenceDTO,
): AlarmSchemesFormType  => {

        const formValues: AlarmSchemesFormType = {
            alarmSchemes: model.map(o => {

                return {
                    id: o.id,
                    name: o.name,
                    tiers: o.tiers.map(v => {

                        const notifications: IReferenceAlarmSchemeTierNotificationDTO[] = [];
                        v.schedules.forEach(x => {

                            x.notificationLists.forEach(z => {

                                const notificationList: IReferenceAlarmSchemeTierNotificationDTO = {
                                    scheduleID: x.id,
                                    notificationListID: z.id,
                                    notificationListName: z.name,
                                    organizationID: z.organizationID
                                };
                                notifications.push(notificationList);

                            });
                        
                        });

                        const tier: IReferenceAlarmSchemeTierDTO = {
                            id: v.id,
                            name: v.name,
                            description: v.description,
                            notifications: notifications,
                            schedules: v.schedules.map(x => {

                                return {

                                    id: x.id,
                                    name: x.name,
                                    notificationLists: x.notificationLists.map(z => {
                                        return {
                                            id: z.id,
                                            name: z.name,
                                            organizationID: z.organizationID
                                        } as IReferenceNotificationListDTO;

                                    })
                                    
                                } as IReferenceAlarmScheduleDTO;

                            })
                        };

                        return tier;
                    }),
                    setpoints: o.setPoints.map(v => {
                        return {
                            id: v.id,
                            displayText: v.name,
                            objectName: v.name,
                            objectType: eLynxObjectTypeEnum.SetPoint
                        } as IeLynxObject
                    })
                    

                } as AlarmSchemeItem;

            })
        };


        let notificationLists: IReferenceNotificationListDTO[] = [];

        referenceData.organizations.forEach(v => {

            const notifications = v.notificationLists.map(z => {

                return {
                    id: z.id,
                    name: z.name,
                    organizationID: v.id
                } as IReferenceNotificationListDTO;

            });

            notificationLists = notificationLists.concat(notifications);
        });


        // map to a type setpoint admin understands so component can be reused.
        const setpointReferenceData: ISetpointReferenceDTO = {

            alarmSchedules: referenceData.schedules.map(o => {
                return {
                    id: o.id,
                    name: o.name,
                    notificationLists: []
                }
            }),
            alarmSchemes: [],
            deviceTypes: [],
            messages: [],
            notificationLists: notificationLists,
            organizations: [],
            recipients: [],
            tagAssociationTypes: [],
            unitClassifications: [],
            unitsOfMeasure: [],
            users: []
        };

        formValues.alarmSchemes.forEach(o => {

             AlarmSchemeListUtils.updateAlarmSchemeForm(o, setpointReferenceData);

        });

        return formValues;
    },
}

export default AlarmSchemeAdministrationUtils;
